import React from "react"
import { makeStyles } from "@material-ui/styles"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import useFormFields from "../libs/useFormFields"
import Button from "../components/Button"
import SelectField from "../components/SelectField"
import SwitchField from "../components/SwitchField"
import TextAreaField from "../components/TextAreaField"
import TextField from "../components/TextField"

const documentsItems = [
  {
    addTime: "timeMinutes",
    key: "sendMinutes",
    title: "Meeting Minutes",
  },
  {
    addTime: "timeBudgets",
    key: "sendBudgets",
    title: "Budgets",
  },
  {
    key: "sendFinancials",
    title: "Financial",
  },
  {
    key: "sendBylaws",
    title: "Bylaws & Declarations",
  },
  {
    key: "sendRules",
    title: "Rules & Regulations",
  },
]

const times = [
  {
    label: "Past Year",
    value: 1,
  },
  {
    default: true,
    label: "Past 2 Years",
    value: 2,
  },
  {
    label: "Past 3 Years",
    value: 3,
  },
  {
    label: "Past 4 Years",
    value: 4,
  },
  {
    label: "All",
    value: "all",
  },
]

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    margin: "auto",
    marginTop: theme.spacing(5),
    maxWidth: 600,
  },
  grid: {
    alignItems: "center",
    display: "flex",
  },
  select: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}))

const SendDocuments = ({ sendData, setSendData, setPreview, ...props }) => {
  const classes = useStyles()

  const [fields, handleFieldChange] = useFormFields({
    email: "",
    message: "",
    sendMinutes: true,
    timeMinutes: 2,
    sendBudgets: true,
    timeBudgets: 2,
    sendFinancials: true,
    sendBylaws: true,
    sendRules: true,
  })

  function validateForm() {
    return true //fields.email.length > 0
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setPreview(true)
    setSendData({
      ...sendData,
      fields,
    })
  }

  return (
    <form onSubmit={handleSubmit} {...props}>
      <Grid container spacing={3}>
        {documentsItems.map((documentItem) => (
          <Grid container spacing={3} key={documentItem.key} style={{ margin: 0 }}>
            <Grid item xs={4} className={classes.grid}>
              <FormControlLabel
                control={
                  <SwitchField
                    checked={fields[documentItem.key]}
                    id={documentItem.key}
                    onChange={handleFieldChange}
                  />
                }
                label={documentItem.title}
              />
            </Grid>
            <Grid item xs={8} className={classes.grid}>
              {documentItem.addTime ? (
                <SelectField
                  style={{ maxWidth: 200 }}
                  inputProps={{ className: classes.select }}
                  id={documentItem.addTime}
                  options={times}
                  name={documentItem.addTime}
                  onChange={handleFieldChange}
                  value={fields[documentItem.addTime]}
                />
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        ))}
        <Grid item xs={12}>
          <TextField
            defaultValue={fields.email}
            label="Email"
            id="email"
            onChange={handleFieldChange}
            type="email"
          />
        </Grid>
        <Grid item xs={12}>
          <TextAreaField
            defaultValue={fields.message}
            label="Message"
            id="message"
            onChange={handleFieldChange}
          />
        </Grid>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button disabled={!validateForm()} endIcon={<ChevronRightIcon />} type="submit">
            Preview
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default SendDocuments
